import React from "react";
import { Route, Routes } from "react-router-dom";

import Notifications from "@/components/screens/Notifications";
import NotificationDetails from "./NotificationDetails";
import { NOTIFICATIONS_MESSAGES } from "@/messages/notifications/notifications.messages";

const NotificationsPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang/:notificationId" element={<NotificationDetails />} />
      <Route path="/:lang" element={<Notifications messages={NOTIFICATIONS_MESSAGES} />} />
      <Route path="/" element={<Notifications messages={NOTIFICATIONS_MESSAGES} />} />
    </Routes>
  );
};

export default NotificationsPage;
